import { useSelector } from "react-redux";
import HashtagIcon from "assets/icons/Hashtag";
import "../../Factor2/print/fishPrint.css";
import { useRef } from "react";
import { MiladiToJalali } from "helpers/dataFormat";
export default function useRemittancePrint(props?: { remittances?: any }) {
    const store = useSelector((state: any) => state);
    const remittances = Array.isArray(props?.remittances) ? props?.remittances : (store.remittanceReducer?.remittance ? [store.remittanceReducer?.remittance] : null);
    const business = store.businessReducer.business.business;
    const contentRef = useRef<any>(null);

    let content = <></>;
    if (remittances) {
        content = (<div ref={contentRef} className="flex flex-col">
            {

                remittances.map((remittance: any, ix: number) => {
                    //const splitedDate = remittance.date.split('-')
                    //MiladiToJalali(parseFloat(splitedDate[0]),parseFloat(splitedDate[1]),parseFloat(splitedDate[2]),true)
                    
                    const convertDate = remittance.date
                    let sumQuantity=0
                    return (<div
                        key={ix}
                        className="bg-white flex flex-col items-center text-black p-5 h-[730px]"

                        style={{ direction: "rtl", lineHeight: '30px' }}
                    >
                        <div className="w-full row">
                            <div className="col-4"></div>
                            <div className="col-4">
                                <div className="text-[20px] font-extrabold text-center pb-1">
                                    {remittance.type === 'enter' ? 'رسید' : 'حواله'} انبار
                                </div>
                                <div className="text-[20px] font-extrabold text-center pb-1">
                                    {business.legalName}
                                </div>
                            </div>
                            <div className="text-left col-4">
                                <div
                                    className="text-[16px] text-left pb-1">شماره {remittance.type === 'enter' ? 'رسید' : 'حواله'}: {remittance.accountingCode}</div>
                                <div className="text-[16px] pb-1">تاریخ: {convertDate}</div>
                            </div>
                        </div>

                        <div className="w-full row border-2  border-[#000]" style={{ fontSize: '14px' }}>
                            <div className="row">
                                <div className="col-6 flex flex-row">
                                    <p>انبار:</p>
                                    <p className="mr-3">{remittance.Warehouse.title}</p>
                                </div>
                                <div className="col-6 flex flex-row">
                                    <p>تحویل گیرنده:</p>
                                    <p className="mr-3">{remittance.delivery ?? ''}</p>
                                </div>
                                <div className="col-12 flex flex-row">
                                    <p>شرح {remittance.type === 'enter' ? 'رسید' : 'حواله'}:</p>
                                    <p className="mr-3">{remittance.description}</p>
                                </div>
                            </div>
                        </div>

                        <div className="w-full row border-2  border-[#000] mt-4 border-bottom-0">
                            <table
                                className="w-full table-bordered" style={{ lineHeight: '30px' }}>
                                <thead>
                                    <th style={{
                                        fontSize: "12px", borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>
                                        <HashtagIcon color="black" style={{ transform: "scale(1.0)" }} />
                                    </th>
                                    <th style={{
                                        fontSize: "12px", borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}
                                        className="w-[140px]">کد کالا
                                    </th>
                                    <th style={{
                                        fontSize: "12px", borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>شرح کالا
                                    </th>
                                    <th style={{
                                        fontSize: "12px", borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>مقدار
                                    </th>
                                    <th style={{
                                        fontSize: "12px", borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>واحد
                                    </th>
                                    <th style={{
                                        fontSize: "12px",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>توضیحات
                                    </th>
                                </thead>
                                <tbody>
                                    {remittance?.Product_Bills?.map((item: any, i: number) => {
                                        sumQuantity+=Math.abs(item.quantity)
                                        return (
                                            <tr key={i}>
                                                <td className="text-center text-[11px] font-semibold" style={{
                                                    borderLeft: "2px solid black",
                                                    borderBottom: "2px solid black",
                                                    padding: "3px",
                                                    textAlign: 'center'
                                                }}>{i + 1}</td>
                                                <td className="px-0 py-1"
                                                    style={{
                                                        borderLeft: "2px solid black",
                                                        borderBottom: "2px solid black",
                                                        padding: "3px",
                                                        textAlign: 'center'
                                                    }}>
                                                    <span className="text-xs font-semibold">{item.Product.accountingCode}</span>
                                                </td>
                                                <td style={{
                                                    borderLeft: "2px solid black",
                                                    borderBottom: "2px solid black",
                                                    padding: "3px",
                                                    textAlign: 'center'
                                                }}>
                                                    <span className="text-xs font-semibold">{item.Product.title}</span>
                                                </td>
                                                <td style={{
                                                    borderLeft: "2px solid black",
                                                    borderBottom: "2px solid black",
                                                    padding: "3px",
                                                    textAlign: 'center'
                                                }}>
                                                    <span>{Math.abs(item.quantity)}</span>
                                                </td>
                                                <td className="text-[11px] font-semibold" style={{
                                                    borderLeft: "2px solid black",
                                                    borderBottom: "2px solid black",
                                                    padding: "3px",
                                                    textAlign: 'center'
                                                }}>{item.unit}</td>
                                                <td className="text-[11px] font-semibold"
                                                    style={{
                                                        borderBottom: "2px solid black",
                                                        padding: "3px",
                                                        textAlign: 'center'
                                                    }}>{item.description}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="w-full border-2 border-[#000]">
                        <div className="flex flex-row place-content-center border-l ">
                                <p>جمع مقدار:</p>
                                <p>{sumQuantity}</p>
                            </div>
                        </div>
                        <div className="w-full row mt-4" style={{ height: '100px' }}>
                            <div className="col-6 border-2 border-[#000]" style={{ borderLeft: 0 }}>
                                <p>نام و امضا تحویل دهنده</p>
                            </div>
                            <div className="col-6 border-2  border-[#000]">
                                <p>نام و امضا تحویل گیرنده</p>
                            </div>
                        </div>
                    </div>
                    )
                })
            }
        </div>
        )
    }
    return { content, contentRef };
}
